import { ltrim } from './support-b3';
import { type Row, type PortEnv, get, has, isArray, isInt, isFloat, values, intval, strval, floatval, f, json_encode, array_is_list, fromJson, read } from './support-b3';
interface Deps {
    check_uuid(id: string): boolean;
}
/** PHP: ft_crafting_wip_decode_payload_object (includes/functions/janus/statuses/crafting_wip_helpers.php:315) */
export function ftCraftingWipDecodePayloadObject(raw: unknown): Row | null {
    if (typeof raw !== 'string' || raw === '' || ltrim(raw)[0] !== '{')
        return null;
    let obj: Row;
    try {
        obj = fromJson(raw, true) as Row;
    }
    catch {
        return null;
    }
    return isArray(obj) && isInt(get(obj, 'v')) && [1, 2].includes(Number(get(obj, 'v'))) ? obj : null;
}
/** PHP: ft_crafting_progress_payload_parse (includes/functions/janus/statuses/crafting_wip_helpers.php:79) */
export function ftCraftingProgressPayloadParse(raw: unknown, env: PortEnv<Deps>): Row | null {
    const obj = ftCraftingWipDecodePayloadObject(raw);
    if (obj === null)
        return null;
    const version = Number(intval(get(obj, 'v'))), target = get(obj, 't') ?? null, state = get(obj, 'st') ?? null, req = get(obj, 'req') ?? null, acc = get(obj, 'acc') ?? null;
    if (typeof target !== 'string' || !env.deps.check_uuid(target) || !['active', 'resolving'].includes(state) || !isInt(req) || req < 1 || !isInt(acc) || acc < 0 || !isArray(get(obj, 'm')) || !array_is_list(get(obj, 'm')))
        return null;
    const manifest: Row[] = [];
    for (const e of values(get(obj, 'm'))) {
        if (!isArray(e) || !['i', 'e', 'q'].every(k => has(e, k)))
            return null;
        if (typeof get(e, 'i') !== 'string' || !env.deps.check_uuid(get(e, 'i')) || !isInt(get(e, 'q')) || get(e, 'q') < 1 || get(e, 'e') !== null && (typeof get(e, 'e') !== 'string' || !env.deps.check_uuid(get(e, 'e'))))
            return null;
        manifest.push({ item_uuid: get(e, 'i'), template_id: get(e, 'e'), qty: get(e, 'q') });
    }
    const ids: string[] = [];
    if (has(obj, 'rw')) {
        if (!isArray(get(obj, 'rw')) || !array_is_list(get(obj, 'rw')))
            return null;
        for (const id of values(get(obj, 'rw'))) {
            if (typeof id !== 'string' || !env.deps.check_uuid(id))
                return null;
            ids.push(id);
        }
    }
    if (state === 'active' && has(obj, 'rw') || state === 'resolving' && (acc < req || ids.length === 0))
        return null;
    const outputs: Row[] = [];
    let formula = 0, size: unknown = null;
    if (version >= 2) {
        if (!has(obj, 'o') || !isArray(get(obj, 'o')) || !array_is_list(get(obj, 'o')) || values(get(obj, 'o')).length === 0 || !has(obj, 'fv') || !isInt(get(obj, 'fv')) || get(obj, 'fv') < 1 || !has(obj, 'sz'))
            return null;
        size = get(obj, 'sz');
        if (size !== null && (typeof size !== 'string' || !env.deps.check_uuid(size)))
            return null;
        for (const o of values(get(obj, 'o'))) {
            if (!isArray(o) || !['i', 'e', 'q', 's', 'w'].every(k => has(o, k)))
                return null;
            if (typeof get(o, 'i') !== 'string' || !env.deps.check_uuid(get(o, 'i')) || !isInt(get(o, 'q')) || get(o, 'q') < 1 || get(o, 'e') !== null && (typeof get(o, 'e') !== 'string' || !env.deps.check_uuid(get(o, 'e'))) || get(o, 's') !== null && (typeof get(o, 's') !== 'string' || !env.deps.check_uuid(get(o, 's'))) || get(o, 'w') !== null && (!(isInt(get(o, 'w')) || isFloat(get(o, 'w'))) || f(get(o, 'w')) < 0 || !Number.isFinite(f(get(o, 'w')))))
                return null;
            if (get(o, 's') !== null && size === null)
                return null;
            outputs.push({ item_uuid: get(o, 'i'), template_id: get(o, 'e'), qty: get(o, 'q'), size_id: get(o, 's'), weight_override: get(o, 'w') === null ? null : floatval(get(o, 'w')) });
        }
        formula = get(obj, 'fv');
    }
    return { target_id: target, version, state, required_seconds: req, accrued_seconds: acc, manifest, resolving_worker_status_ids: ids, outputs, formula_version: formula, requested_size: size };
}
/** PHP: ft_crafting_progress_payload (includes/functions/janus/statuses/crafting_wip_helpers.php:220) */
export function ftCraftingProgressPayload(status: Row, env: PortEnv<Deps>): Row | null { return ftCraftingProgressPayloadParse(get(status, 'status_casting_targets_arr') ?? null, env); }
/** PHP: {closure@238:961} (includes/functions/janus/statuses/crafting_wip_helpers.php:238) */
export function closure238961(e: Row, env: PortEnv<Deps>): Row { return { i: strval(read(e, 'item_uuid', env)), e: get(e, 'template_id') ?? null, q: intval(read(e, 'qty', env)) }; }
/** PHP: {closure@252:1056} (includes/functions/janus/statuses/crafting_wip_helpers.php:252) */
export function closure2521056(o: Row, env: PortEnv<Deps>): Row { return { i: strval(read(o, 'item_uuid', env)), e: get(o, 'template_id') ?? null, q: intval(read(o, 'qty', env)), s: get(o, 'size_id') ?? null, w: get(o, 'weight_override') != null ? floatval(get(o, 'weight_override')) : null }; }
/** PHP: ft_crafting_progress_payload_encode (includes/functions/janus/statuses/crafting_wip_helpers.php:224) */
export function ftCraftingProgressPayloadEncode(p: Row, env: PortEnv<Deps>): string | false {
    let v = Number(intval(p.version ?? 2));
    if (![1, 2].includes(v))
        v = 2;
    const wire: Row = { t: strval(read(p, 'target_id', env)), v, st: strval(read(p, 'state', env)), req: intval(read(p, 'required_seconds', env)), acc: intval(read(p, 'accrued_seconds', env)), m: values(p.manifest ?? []).map(e => closure238961(e, env)) };
    const ids = values(p.resolving_worker_status_ids ?? []);
    if (ids.length)
        wire.rw = ids;
    if (v >= 2) {
        wire.o = values(p.outputs ?? []).map(o => closure2521056(o, env));
        wire.fv = Math.max(1, Number(intval(p.formula_version ?? 1)));
        wire.sz = p.requested_size ?? null;
    }
    return json_encode(wire);
}
/** PHP: ft_crafting_worker_payload_parse (includes/functions/janus/statuses/crafting_wip_helpers.php:276) */
export function ftCraftingWorkerPayloadParse(raw: unknown, env: PortEnv<Deps>): Row | null {
    const obj = ftCraftingWipDecodePayloadObject(raw);
    if (obj === null || (get(obj, 'v') ?? null) !== 1)
        return null;
    if (typeof get(obj, 't') !== 'string' || get(obj, 't') === '' || typeof get(obj, 'wip') !== 'string' || !env.deps.check_uuid(get(obj, 'wip')) || !isInt(get(obj, 'ls')) || get(obj, 'ls') < 0)
        return null;
    return { target_id: get(obj, 't'), version: 2, wip_inventory_id: get(obj, 'wip'), last_settled_seconds: get(obj, 'ls') };
}
/** PHP: ft_crafting_worker_payload_encode (includes/functions/janus/statuses/crafting_wip_helpers.php:302) */
export function ftCraftingWorkerPayloadEncode(p: Row, env: PortEnv<Deps>): string | false { return json_encode({ t: strval(read(p, 'target_id', env)), v: 1, wip: strval(read(p, 'wip_inventory_id', env)), ls: intval(read(p, 'last_settled_seconds', env)) }); }
